import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

const Footer = () => {
  const { t, lang } = useI18n();
  return (
    <footer className="border-t mt-16" style={{ borderColor: "#27272A" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
        <div className="flex flex-col md:flex-row gap-6 md:gap-12 items-start md:items-center justify-between">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <img src="/logo.svg" alt="" width="32" height="32" />
              <div className="font-heading text-lg">SPORTS NUTRITION <span style={{ color: "#FF3B30" }}>ENGINE</span></div>
            </div>
            <div className="font-mono text-[10px] tracking-widest text-white/40">
              Sport-Calibrated · Adaptive Hydration · Symptom-Driven
            </div>
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
            <Link to="/about" data-testid="footer-about" className="text-white/70 hover:text-white">
              {lang === "ro" ? "Despre" : "About"}
            </Link>
            <Link to="/privacy" data-testid="footer-privacy" className="text-white/70 hover:text-white">
              {lang === "ro" ? "Confidențialitate" : "Privacy"}
            </Link>
            <Link to="/terms" data-testid="footer-terms" className="text-white/70 hover:text-white">
              {lang === "ro" ? "Termeni" : "Terms"}
            </Link>
            <Link to="/pricing" data-testid="footer-pricing" className="text-white/70 hover:text-white">
              {lang === "ro" ? "Prețuri" : "Pricing"}
            </Link>
            <a
              href="mailto:iuliantriboi@gmail.com"
              className="text-white/70 hover:text-white"
              data-testid="footer-contact"
            >
              Contact
            </a>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t" style={{ borderColor: "#1F1F1F" }}>
          <div className="font-mono text-[10px] tracking-widest text-white/50 leading-relaxed">
            <div className="font-bold text-white/70">TRIBOIAI LLC</div>
            <div>File No. 2026-001869654</div>
            <div>1021 E Lincolnway Suite 9733, Cheyenne, WY 82001, USA</div>
            <div>contact: <a href="mailto:iuliantriboi@gmail.com" className="text-white/70 hover:text-white">iuliantriboi@gmail.com</a></div>
            <div className="mt-2">© 2026. All Rights Reserved.</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
